import DemoPage from "./demo.jsx";

export default function DemoDe() {
  return <DemoPage forcedLang="de" />;
}